import { FlagState } from './types';
/**
 * All allowed feature flags and their default values
 */
export const features = {
    feature_fuzzy_search: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_dark_mode: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_new_template_flow: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_shared_with_me: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_all_documents_route: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_advanced_approval_workflow: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_rtc_pleditor: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_review: {
        value: FlagState.DISABLED,
        force: false,
    },
    feature_api_key_management: {
        value: FlagState.DISABLED,
        force: false,
    },
};
export const featureFlagKeys = Object.keys(features);
